import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset any body styles that might interfere with scrolling
    document.body.style.overflow = '';
    document.body.style.height = '';
    
    // Force scroll to top
    window.scrollTo(0, 0);
    
    // Also try scrolling the document element
    document.documentElement.scrollTop = 0;
    
    // For Safari/iOS
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;









